import { inject, Injectable } from '@angular/core';
import { ListingFilesModalService } from "./listing-files-modal.service";
import { RecordUpdateRequestParams } from "../../../../../../../core/types/records-table.types";
import { ListingFileData } from "../types/listing-file-data.types";
import { ListingPathStateService } from "./listing-path-state.service";

@Injectable({
  providedIn: 'root'
})
export class ListingFilesSyncService {
  private listingFilesModalService: ListingFilesModalService = inject(ListingFilesModalService);
  private listingPathStateService: ListingPathStateService = inject(ListingPathStateService);

  public async updateFilePriority(fileId: number, uspPriority: number): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.listingPathStateService.pathState(),
      recordId: fileId,
      fieldName: 'uspPriority',
      value: uspPriority
    };

    await this.listingFilesModalService.updatedRecordField<ListingFileData>(params);
  }
}
